module.exports = __webpack_public_path__ + "img/activity-heart.b47fe1fa.svg";